import { render, staticRenderFns } from "./StoreDrawer.vue?vue&type=template&id=3c4e3516&"
import script from "./StoreDrawer.vue?vue&type=script&lang=ts&"
export * from "./StoreDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./StoreDrawer.vue?vue&type=style&index=0&id=3c4e3516&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QInput,QBtn,QIcon,QCheckbox} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QBtn,QIcon,QCheckbox})
